import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

/** Accepting an item no screenshot or document supports needs a second look.
 * Uploading first is the default way out; accepting anyway stays possible. */
export function AcceptWithoutEvidenceDialog({
  open,
  onUpload,
  onAcceptAnyway,
  onCancel,
}: {
  open: boolean;
  onUpload: () => void;
  onAcceptAnyway: () => void;
  onCancel: () => void;
}) {
  return (
    <AlertDialog
      open={open}
      onOpenChange={(next) => {
        if (!next) {
          onCancel();
        }
      }}
    >
      <AlertDialogContent
        onCloseAutoFocus={(event) => {
          // Upload moves focus to the upload button itself.
          event.preventDefault();
        }}
      >
        <AlertDialogHeader>
          <AlertDialogTitle>Accept without evidence?</AlertDialogTitle>
          <AlertDialogDescription>
            No screenshot, report or document supports this item. You can upload
            evidence first, or accept it anyway.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onUpload}>
            Upload evidence
          </AlertDialogCancel>
          <AlertDialogAction onClick={onAcceptAnyway}>
            Accept anyway
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
